import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

export const useLayout = createGlobalState(() => {
  const breakpoints = useBreakpoints(breakpointsTailwind)
  const isLandscape = useMediaQuery('(orientation: landscape)')

  const smAndUp = breakpoints.greaterOrEqual('sm')
  const mdAndUp = breakpoints.greaterOrEqual('md')
  const lgAndUp = breakpoints.greaterOrEqual('lg')
  const xlAndUp = breakpoints.greaterOrEqual('xl')

  const { height } = useWindowSize()
  const pageHeight = computed(
    () => `calc(${height.value}px - var(--header-height))`,
  )
  const doubledPageHeight = computed(
    () => `calc(${height.value * 2}px - var(--header-height))`,
  )

  return {
    smAndUp,
    mdAndUp,
    lgAndUp,
    xlAndUp,
    isLandscape,
    pageHeight,
    doubledPageHeight,
  }
})
